import { Record } from 'immutable';
export const DETERMINING_INSTALL_MODE = 'DETERMINING';
export const makeDeterminingInstallMode = Record({
  type: DETERMINING_INSTALL_MODE,
  error: undefined,
  retrievalId: 0
});